import { Ajax } from '../admin/ajax_helper';
declare var jQuery: any;
declare let productLocalize: any;
import { SpinnerController } from './spinner_controller';

export class ProfileFileUpload {
    ajax: Ajax;

    private spinnerController: SpinnerController;

    constructor() {
        this.ajax = new Ajax( productLocalize.ajax_url );
        this.spinnerController = new SpinnerController();

    }
    public startEvents() {
        this.handleDownloadCreditLogs();
    }

    private handleDownloadCreditLogs() {
        jQuery('#vm_credit_modal_download_action').on('click', function() {
            let fileType = jQuery('#file_type').val();
            let nonce = jQuery(this).data('nonce');
            let fromDate = jQuery('#from_date').val();
            let toDate = jQuery('#to_date').val();
            ProfileFileUpload.block_element('.content-wrapper', true);
            jQuery.ajax({
                url: productLocalize.ajax_url,
                type: 'POST',
                data: {
                    action: 'vm_credit_logs_download',
                    file_type: fileType,
                    security: nonce,
                    from_date: fromDate,
                    to_date: toDate
                },
                xhrFields: {
                    responseType: 'blob' // Handle binary data (CSV/PDF)
                },
                success: function(response, status, xhr) {
                    let filename = fileType === 'csv' ? 'credit_logs.csv' : 'credit_logs.pdf';
                    let blob = new Blob([response], { type: xhr.getResponseHeader('Content-Type') });
                    let link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);
                    link.download = filename;
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    ProfileFileUpload.block_element('.content-wrapper', false);
                },
                error: function() {
                    alert('Error generating file. Please try again.');
                    ProfileFileUpload.block_element('.content-wrapper', false);
                }
            });
        });
    
        jQuery('#vm_credit_modal_close_action').on('click', (e: any) => {
            e.preventDefault(); // Prevent the default link behavior

            // Safely select the close button and cast it to HTMLAnchorElement
            const closeButton = document.querySelector('.close') as HTMLAnchorElement;

            // Trigger click on the close button
            closeButton.click();
        });
    }

    public static block_element(element: string, isblock: boolean){
        if(isblock){
            jQuery( element ).block({
                message: null,
                overlayCSS: {
                    background: '#fff',
                    opacity: 0.6
                }
            });
        } else{
            jQuery( element ).unblock({
                message: null,
                overlayCSS: {
                    background: '#fff',
                    opacity: 0.6
                }
            });
        }
    }

}


// Initialize and start events when document is ready
jQuery(document).ready(function () {
    const profileFileUpload = new ProfileFileUpload();
    profileFileUpload.startEvents();
});